import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

import {ADDRESS_INFO_CONTAINER_HEIGHT_IN_PX} from '../../lib/constants'

export const backButton = css`
  inset-block-end: ${spacing(3)};
  position: absolute;
  inset-inline-start: ${spacing(1.5)};
  z-index: 1;
`

export const geolocationControl = {
  root: css`
    inset-block-end: ${spacing(3)};
    position: absolute;
    inset-inline-end: 0;
    z-index: 1;
  `,
}

export const map = css`
  // spacing - поправка на закругления краёв у блока с адресом, чтобы карта была под ним
  block-size: calc(100% - ${ADDRESS_INFO_CONTAINER_HEIGHT_IN_PX} + ${spacing(2)});
  position: relative;
  inline-size: 100%;
`

export const pinIcon = css`
  inset-inline-start: 50%;
  position: absolute;
  inset-block-start: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`
